import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayoutV2 from 'src/layouts/v2/MainLayout';
import TicketLayout from 'src/layouts/v2/TicketLayout';
import SubLayout from 'src/layouts/v2/ExternalLayout';
import type { RouteGroup } from './types';

// Lazy load Ticket components
const TicketManagement = lazy(() => import('src/pages/v2/TicketManagement'));
const Tickets = lazy(() => import('src/pages/v2/Ticket/Tickets'));
const AddTicket = lazy(() => import('src/pages/v2/Ticket/AddTicket'));
const TicketDetailSolutionAdd = lazy(
  () => import('src/pages/v2/Ticket/TicketDetail/TicketDetailSolution/TicketDetailSolutionAdd')
);

export const ticketRoutes: RouteGroup = [
  {
    path: urlPath.hrTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    redirect: urlPath.ticketRaising.location,

    hasSubHeader: false
  },
  {
    path: urlPath.hrConfirm.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    redirect: urlPath.ticketRaising.location,
    hasSubHeader: false
  },
  {
    path: urlPath.ticketRaising.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TicketManagement,
    hasSidebar: false,
    hasSubHeader: false
  },

  {
    path: urlPath.myTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: urlPath.ticket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.approval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: urlPath.accept.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: urlPath.solution.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: urlPath.handle.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },

  // Ticket Detail Routes
  {
    path: `${urlPath.myTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: `${urlPath.approval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: `${urlPath.accept.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: `${urlPath.solution.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },
  {
    path: `${urlPath.handle.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: Tickets,
    hasSidebar: true
  },

  // Add and Edit Ticket Routes
  {
    path: urlPath.ticketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.ticketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Sub Routes for External Layout
  {
    path: urlPath.ticketAddSub.location,
    Layout: MainLayoutV2,
    SubLayout: SubLayout,
    Component: AddTicket,
    isUsePathV2: true,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.ticketEditSub.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: SubLayout,
    Component: AddTicket,
    isUsePathV2: true,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Solution Routes
  {
    path: urlPath.solutionAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TicketDetailSolutionAdd,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.solutionEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TicketDetailSolutionAdd,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  }
];
